<!-- SamplesView.vue -->
<template>
  <section>
    <b-breadcrumb align="is-left" size="is-small">
      <b-breadcrumb-item @click.native="$router.push({ name: 'eden-samples' })">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Detalle</b-breadcrumb-item>
    </b-breadcrumb>

    <b-loading :active="loading" :is-full-page="false"></b-loading>

    <div v-if="item" class="mb-4">
      <h1 class="title is-4">Detalle de muestra</h1>

      <b-field horizontal label="id">
        <div class="control">{{ item.id }}</div>
      </b-field>

      <b-field horizontal label="No Muestra">
        <div class="control">{{ item.sample_code }}</div>
      </b-field>

      <b-field horizontal label="Datos enviados a EDEN">
        <div class="control is-expanded">
          <pre class="code-block" >{{ pretty(item.eden_study_created_data) }}</pre>
        </div>
      </b-field>

      <b-field horizontal label="Datos recibidos en EDEN al generar orden">
        <div class="control is-expanded">
          <pre class="code-block" >{{ pretty(item.eden_response) }}</pre>
        </div>
      </b-field>

      <b-field horizontal label="Datos recibidos de EDEN al firmar">
        <div class="control is-expanded">
          <pre class="code-block">{{ pretty(item.eden_study_signed_data) }}</pre>
        </div>
      </b-field>

      <b-field horizontal label="Fecha de registro">
        <div class="control">{{ formatDate(item.created_at, true) }}</div>
      </b-field>

      <b-field horizontal label="Fecha de última actualización">
        <div class="control">{{ formatDate(item.updated_at, true) }}</div>
      </b-field>
    </div>

    <b-message type="is-info" size="is-small" class="mb-3" v-if="item">
      La configuración de <strong>Interpretación</strong>, <strong>Recomendaciones</strong> y <strong>Diagnóstico</strong>
      se guarda en <code>signed_fields_order</code> como <code>[interpretación, recomendaciones, diagnóstico]</code>.
    </b-message>

    <!-- Formulario de configuración -->
    <b-field grouped group-multiline v-if="item" class="columns mt-5">
      <b-field label="Interpretación" class="column is-3">
        <b-select v-model="item.signed_fields_order.interpretation" placeholder="Selecciona" expanded>
          <option :value="0">1</option>
          <option :value="1">2</option>
          <option :value="2">3</option>
        </b-select>
      </b-field>

      <b-field label="Recomendaciones" class="column is-3">
        <b-select v-model="item.signed_fields_order.recommendations" placeholder="Selecciona" expanded>
          <option :value="0">1</option>
          <option :value="1">2</option>
          <option :value="2">3</option>
        </b-select>
      </b-field>

      <b-field label="Diagnóstico" class="column is-3">
        <b-select v-model="item.signed_fields_order.diagnostic" placeholder="Selecciona" expanded>
          <option :value="0">1</option>
          <option :value="1">2</option>
          <option :value="2">3</option>
        </b-select>
      </b-field>
    </b-field>

    <!-- 3 campos de texto largo -->
    <div v-if="item" class="mb-5 mt-5">
      <div class="sample-field mb-2">
        <h2 class="heading">Valor de campo 1</h2>
        <span v-html="item.field1"></span>
      </div>
      <div class="sample-field  mb-2">
        <h2 class="heading">Valor de campo 2</h2>
        <span v-html="item.field2"></span>
      </div>
      <div class="sample-field mb-2">
        <h2 class="heading">Valor de campo 3</h2>
        <span v-html="item.field3"></span>
      </div>

    </div>

    <div class="buttons" v-if="item">
      <b-button type="is-primary" :disabled="saving" @click="save">
        <b-icon icon="save"></b-icon>
        <span>Guardar</span>
      </b-button>
      <b-button @click="$router.push({ name: 'eden-samples' })" outlined>
        <b-icon icon="arrow-left"></b-icon>
        <span>Volver</span>
      </b-button>
      <b-button type="is-danger" :disabled="saving" @click="removeEdenContent">
        <b-icon icon="close"></b-icon>
        <span>Borrar contenido de la firma Eden</span>
      </b-button>
    </div>

    <b-notification v-if="!item && !loading" type="is-warning" :closable="false">
      No se encontró la muestra solicitada.
    </b-notification>
  </section>
</template>

<script>
export default {
  name: 'SamplesView',
  props: {
    sampleCode: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      item: null,
      // Form: por defecto vacío
      form: {
        interpretacion: null,
        recomendaciones: null,
        diagnostico: null,
        longText1: '',
        longText2: '',
        longText3: ''
      }
    }
  },
  mounted () {
    this.wrapper = document.getElementById("main-wrapper");
    this.wrapper.classList.add("is-expanded");
    this.fetchItem()
  },
  methods: {
    async fetchItem () {
        this.loading = true
        this.$http.get(`imaging/samples/${this.sampleCode}`).then(({data}) => {
          this.item = data.data;
        }).catch(error => {
          this.$buefy.toast.open({ message: 'No se pudo cargar la muestra', type: 'is-danger' })
        }).finally(() => {
          this.loading = false
        })
    },
    async save () {
      this.saving = true
      this.$http.put(`imaging/samples/${this.sampleCode}`, {
        interpretation: this.item.signed_fields_order.interpretation,
        recommendations: this.item.signed_fields_order.recommendations,
        diagnostic: this.item.signed_fields_order.diagnostic,
      }).then(() => {
        this.$buefy.toast.open({ message: 'Configuración guardada', type: 'is-success' })
        this.fetchItem() // Refresca datos
      }).catch((error) => {
        this.$alfalab.showError(error, true);
      }).finally(() => {
        this.saving = false
      })
    },
    pretty (obj) {
      // Muestra JSON bonito; si es string intenta parsear
      if (obj == null) return '—'
      try {
        const parsed = typeof obj === 'string' ? JSON.parse(obj) : obj
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        // Si no parsea, muestra tal cual
        return typeof obj === 'string' ? obj : JSON.stringify(obj, null, 2)
      }
    },
    formatDate (value, withTime = false) {
      if (!value) return '—'
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return String(value)
      const pad = (n) => (n < 10 ? '0' + n : n)
      const yyyy = d.getFullYear()
      const mm = pad(d.getMonth() + 1)
      const dd = pad(d.getDate())
      if (!withTime) return `${yyyy}-${mm}-${dd}`
      const hh = pad(d.getHours())
      const mi = pad(d.getMinutes())
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}`
    },
    removeEdenContent(){
      this.$buefy.dialog.confirm({
        title: 'Confirmar',
        message: '¿Estás seguro de borrar el contenido de EDEN para esta muestra? Esta acción no se puede deshacer.',
        confirmText: 'Sí, borrar',
        type: 'is-danger',
        onConfirm: () => {
          this.saving = true
          this.$http.delete(`imaging/samples/${this.sampleCode}`).then(() => {
            this.$buefy.toast.open({ message: 'Contenido de EDEN borrado', type: 'is-success' })
            this.fetchItem();
          }).catch((error) => {
            this.$alfalab.showError(error, true);
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.code-block {
  background: #f6f8fa;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  max-height: 320px;
  overflow: auto;
  border: 1px solid #e5e7eb;
  max-width: 450px;
}
.mb-4 { margin-bottom: 1rem; }
.mb-3 { margin-bottom: 0.75rem; }
.mb-5 { margin-bottom: 1.25rem; }

.sample-field {
  border: 1px darkgray solid;
  background: white;
  padding: 10px;
  max-height: 320px;
  overflow: auto;
}
</style>
